<div [class]="typologies" class="tw-bg-white">
  @if (isMbGroup) {
    <ia-parrainage-filleul-header />
  }
  @if (isLoading()) {
    <div class="tw-flex tw-min-h-screen tw-items-center tw-justify-center">
      <ia-loader />
    </div>
  }
  <router-outlet />
</div>
